import { render, staticRenderFns } from "./SendExamsTemplate.vue?vue&type=template&id=18e29660&"
import script from "./SendExamsTemplate.vue?vue&type=script&lang=js&"
export * from "./SendExamsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports